let server = process.env.VUE_APP_SERVER || "";
const host = window.location.hostname;

if (
  server.includes("fazendas") &&
  (host.includes("localhost") || host.startsWith("dev-"))
) {
  const url = new URL(server);
  const subdomain = url.hostname.startsWith("dev-")
    ? url.hostname
    : `dev-${url.hostname}`;
  url.hostname = subdomain;
  server = url.toString();
}

server = server.replace(/\/$/, "");

export { server };
